<template>
    <div>
 
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                  <text-input type="hidden" v-model="form.parent_type_id" :error="form.errors.parent_type_id" />  
                  <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full w-full" :label="__('Nombre del Lugar')" />

                  <select-edit-input :value="equipament.type"
                  :editable="true"
                   :placeholder="__('Type Location')" :onInput="doFilter" :items="TypeEquipament" v-model="form.type_id" :error="form.errors.type_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Type Location')">
                  </select-edit-input>
                  <text-input v-model="form.location_name" :placeholder="__('Ubicación Física')" :error="form.errors.location_name" class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Ubicación Física')" />
                  <text-input type="number" v-model="form.ability" :placeholder="__('Capacidad')" :error="form.errors.ability" class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Capacidad')" />
 
                  <select-edit-input :value="equipament.status" 
                  :editable="true"
                   :placeholder="__('Status Location')" :onInput="doFilterStatusEquipament" :items="StatusEquipamentList" v-model="form.status_id" :error="form.errors.status_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Status Location')">
                  </select-edit-input>
 
                 <select-edit-input :value="equipament.responsible_name" 
                  :editable="true"
                   :placeholder="__('Responsible')" :onInput="doFilterResponsible" :items="ResponsibleList" v-model="form.responsible" :error="form.errors.responsible"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Responsible')">
                  </select-edit-input>
                  
                  <select-input :onChange="loadCategories" v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')">
                        <option :value="null" />
                        <option v-for="s in Departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                  </select-input>
                  
                  <select-input  v-model="form.category_id" :error="form.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in Categories" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                  <TextareaInput v-model="form.notes" class="pr-6 pb-8 w-full" :label="__('Notes')"></TextareaInput>
                  
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Save') }}
                        {{ __('Equipament') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import SelectEditInput from '@/Shared/SelectEditInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'



export default {
    metaInfo: { title: 'Create Ticket' },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
        SelectEditInput 
    },
    layout: Layout,
    props: {
        TypeEquipament:Object,
        LocationList : Object,
        equipament: Object,
        StatusEquipamentList :  Object,
        ResponsibleList : Object,
        Departments : Object,
        Categories : Object
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.equipament.name,
                type_id : this.equipament.type_id,
                serie : this.equipament.serie,
                location_id : this.equipament.location_id,
                buys : this.equipament.buys,
                status_id : this.equipament.status_id,
                ability : this.equipament.ability,
                responsible : this.equipament.responsible,
                notes : this.equipament.notes,
                parent_type_id : this.equipament.parent_type_id,
                location_name : this.equipament.location_name,
                department_id: this.equipament.department_id,
                category_id : this.equipament.category_id,

            }),
        }
    },
    created() {
         
    },
    methods: {
        setDefaultValue(arr, key, value){
            const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
            if(find){
                this.form[key] = find['id']
            }
        },
        doFilter(e){
            this.axios.get(this.route('filter.lists.locationstype', {search: e.target.value})).then((res)=>{
                this.TypeEquipament.splice(0, this.TypeEquipament.length, ...res.data);
            })
        },
        doFilterStatusEquipament(e){
            this.axios.get(this.route('filter.lists.locationsStatus', {search: e.target.value})).then((res)=>{
                this.StatusEquipamentList.splice(0, this.StatusEquipamentList.length, ...res.data);
            })
        },
        doFilterResponsible(e){
            this.axios.get(this.route('filter.lists.ResponsibleList', {search: e.target.value})).then((res)=>{
                this.ResponsibleList.splice(0, this.ResponsibleList.length, ...res.data);
            })
        },
        update() {
            this.form.put(this.route('location.update', this.equipament.id))
        },
        loadCategories(e){ 
            this.axios.get(this.route('equipament.ajax', {opc: 'categories', department_id: e.target.value})).then((res)=>{
                this.Categories.splice(0, this.Categories.length, ...res.data);
            })
        }  
    }, 
}
</script>